/* =============================================================================
   assets/rm-global.js
   Site-wide UI: header scroll state, mobile drawer, search drawer,
   store dropdown keyboard nav, and cart count updates.
   ============================================================================= */

(function () {
  'use strict';

  /* ── Header scroll shadow ── */
  const headerEl = document.getElementById('rm-header') || document.getElementById('site-header');
  if (headerEl) {
    const onScroll = () => headerEl.classList.toggle('scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }


  /* ── Mobile nav drawer ── */
  const hamburgerEl = document.getElementById('hamburger');
  const drawerCloseEl = document.getElementById('drawer-close');
  const drawerOverlayEl = document.getElementById('drawer-overlay');
  const drawerEl = document.getElementById('site-drawer');

  function openDrawer() {
    if (!drawerEl) return;
    document.body.classList.add('drawer-open');
    drawerEl.classList.add('open');
    drawerEl.removeAttribute('inert');
    drawerEl.setAttribute('aria-hidden', 'false');
    drawerOverlayEl?.classList.add('open');
    hamburgerEl?.classList.add('open');
    hamburgerEl?.setAttribute('aria-expanded', 'true');
    drawerEl.querySelector('button, a')?.focus();
  }

  function closeDrawer() {
    if (!drawerEl) return;
    document.body.classList.remove('drawer-open');
    drawerEl.classList.remove('open');
    drawerEl.setAttribute('inert', '');
    drawerEl.setAttribute('aria-hidden', 'true');
    drawerOverlayEl?.classList.remove('open');
    hamburgerEl?.classList.remove('open');
    hamburgerEl?.setAttribute('aria-expanded', 'false');
    hamburgerEl?.focus();
  }

  hamburgerEl?.addEventListener('click', openDrawer);
  drawerCloseEl?.addEventListener('click', closeDrawer);
  drawerOverlayEl?.addEventListener('click', closeDrawer);
  // Sub-panel X buttons (data-close) live in the level-2/3 drawer panels. The inline script in
  // site-drawer.liquid closes the drawer for them but runs before #hamburger exists in the DOM,
  // so it can't reset the hamburger. Route them through this closeDrawer too.
  // No 'open' guard: site-drawer's handler fires first and already removes the class.
  document.addEventListener('click', e => {
    if (e.target.closest('[data-close]')) closeDrawer();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawerEl?.classList.contains('open')) closeDrawer();
  });

  // Accordion sections inside the drawer
  window.toggleDrawerSection = function (sectionId) {
    const section = document.getElementById(sectionId);
    if (!section) return;
    const wasExpanded = section.classList.contains('expanded');

    // Collapse all sections first
    document.querySelectorAll('.drawer-section').forEach(s => {
      s.classList.remove('expanded');
      s.querySelector('.drawer-section__trigger')?.setAttribute('aria-expanded', 'false');
    });

    // Expand the clicked one if it wasn't already open
    if (!wasExpanded) {
      section.classList.add('expanded');
      section.querySelector('.drawer-section__trigger')?.setAttribute('aria-expanded', 'true');
    }
  };


  /* ── Search drawer ── */
  const searchToggleEl = document.getElementById('search-toggle');
  const searchDrawerEl = document.getElementById('search-drawer');

  searchToggleEl?.addEventListener('click', () => {
    if (!searchDrawerEl) return;
    const isOpen = searchDrawerEl.classList.toggle('open');
    searchToggleEl.setAttribute('aria-expanded', isOpen);
    if (isOpen) {
      document.body.classList.add('drawer-open');
      searchDrawerEl.querySelector('input')?.focus();
    } else {
      document.body.classList.remove('drawer-open');
    }
  });


  /* ── Store dropdown keyboard support ── */
  const storeBtn = document.getElementById('rh-store-btn');
  storeBtn?.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      storeBtn.click();
    }
  });


  /* ── Cart count update from cart events ── */
  document.addEventListener('cart:updated', e => {
    const count = e.detail?.itemCount;
    if (count === undefined) return;

    let countEl = document.querySelector('.cart-count');
    const cartToggleEl = document.getElementById('cart-toggle');

    if (count > 0) {
      if (countEl) {
        countEl.textContent = count;
      } else if (cartToggleEl) {
        const badge = document.createElement('span');
        badge.className = 'cart-count';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = count;
        cartToggleEl.appendChild(badge);
      }
    } else {
      countEl?.remove();
    }

    cartToggleEl?.setAttribute('aria-label', `Cart (${count} item${count !== 1 ? 's' : ''})`);
  });

})();
